module.exports = __webpack_public_path__ + "static/media/Trash.e29af19b.svg";